import React from 'react';
import Layout from 'layouts/Main';
import Progressions from './Progressions';

async function action(context) {
  return {
    routeName: 'discover',
    title: 'Discover',
    chunks: ['progressions'],
    params: context.params,
    component: (
      <Layout>
        <Progressions params={context.params} />
      </Layout>
    ),
  };
}

export default action;
